import React from 'react'
import { ContentsEl } from './elements'
import { H5 } from '../../../../../../../../../Styles/typography'
import Chapter from './components/chapter'
import 'react-perfect-scrollbar/dist/css/styles.css'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Subscribe } from 'unstated'
import CourseStore from '../../../../../../../Store/CourseStore'

const Contents = () => {
  return (
    <Subscribe to={[CourseStore]}>
      {({ state: { userType, startTime, chapters, enrollments = [] } }) => {
        const enrolledInRecorded = enrollments[0]?.status === 'PAID'

        return (
          <ContentsEl>
            <H5>Course Content</H5>

            <span className='separator' />

            <div className='chapters'>
              <PerfectScrollbar>
                {chapters.map(({ id, ...chapter }, index) => (
                  <Chapter
                    key={id}
                    id={id}
                    {...chapter}
                    index={index + 1}
                    chapters={chapters}
                    disabled={!(enrolledInRecorded || userType === 'teacher')}
                    startTime={startTime}
                  />
                ))}
                <div className='padding' />
              </PerfectScrollbar>
            </div>
          </ContentsEl>
        )
      }}
    </Subscribe>
  )
}

export default Contents
